angular.module("dx.webapp.node", [
	"digiexam.node",
	"digiexam.services",
	"dx.webapp.api",
	"dx.webapp.clientVersion",
	"dx.webapp.navigation",
	"dx.webapp.roles",
	"dx.webapp.validation",
	"UIStateManager",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",

	"angularFileUpload",
	"ngPasteFrom",
	"ngRaven",
]);
